/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ProgressDetailsForWellArchitectedAutoAssessment extends models.ProgressDetails {
    getFixupPrototypeFunction() { return ProgressDetailsForWellArchitectedAutoAssessment.fixupPrototype; }

    static newInstance(model: Partial<ProgressDetailsForWellArchitectedAutoAssessment>): ProgressDetailsForWellArchitectedAutoAssessment {
        let obj = Object.assign(new ProgressDetailsForWellArchitectedAutoAssessment(), model);
        ProgressDetailsForWellArchitectedAutoAssessment.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ProgressDetailsForWellArchitectedAutoAssessment>): ProgressDetailsForWellArchitectedAutoAssessment {
        if (!model) return null;
        return ProgressDetailsForWellArchitectedAutoAssessment.newInstance(<ProgressDetailsForWellArchitectedAutoAssessment> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ProgressDetailsForWellArchitectedAutoAssessment) {
        if (!obj) return;

        models.ProgressDetailsForWellArchitectedAutoAssessment.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ProgressDetailsForWellArchitectedAutoAssessment): boolean {
        if (models.ProgressDetails.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ProgressDetailsForWellArchitectedAutoAssessment.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * If set, default workload is created
     */
    default_workload_created: boolean;

    /**
     * If set, default assessment is created
     */
    default_assessment_created: boolean;

    /**
     * If set, assessment run report is generated
     */
    report_generated: boolean;

    /**
     * If set, auto assessment notification is triggered
     */
    notification_triggered: boolean;

}
